import React, { useEffect } from 'react';

export default function Kbee() {
  useEffect(() => {
    document.location.replace('https://kbee.app?ref=drivetools')
  }, [])
  return <></>
}